
import { defineComponent } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import FractionalCdSlider from './FractionalCdSlider.vue';

export default defineComponent({
  name: 'DurationContent',
  components: { FractionalCdSlider },
  props: {
    sliderIndex: { type: Number, default: 3, required: false }
  },
  data: function () {
    return {
      currentValue: this.sliderIndex,
      clientConstants: ClientConstants
    };
  },
  methods: {
    durationChanged(event: Event): void {
      this.$emit('durationChanged', event);
    },
    viewButtonClicked() {
      // TODO pass back duration value
      this.$emit('closeDurationModal');
    },
    backButtonClicked() {
      this.$emit('backButtonClicked');
    }
  }
});
